import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=6e5f5d7d&scoped=true"
import script from "./LoginNew.vue?vue&type=script&lang=js"
export * from "./LoginNew.vue?vue&type=script&lang=js"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=6e5f5d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f5d7d",
  null
  
)

export default component.exports